module.exports = __webpack_public_path__ + "img/list.40918752.svg";